import { render, staticRenderFns } from "./emailManage.vue?vue&type=template&id=3d531a94&scoped=true"
import script from "./emailManage.vue?vue&type=script&lang=js"
export * from "./emailManage.vue?vue&type=script&lang=js"
import style0 from "./emailManage.vue?vue&type=style&index=0&id=3d531a94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d531a94",
  null
  
)

export default component.exports